module.exports = __webpack_public_path__ + "static/header-layer-3-272150659ef0eb0bc939b5424788b3ad.png";